
import { defineComponent } from "vue";
import Signin from "./Signin.vue";
import ForceNewPassword from "./ForceNewPassword.vue";
import ResetPassword from "./ResetPassword.vue";
import ResetPasswordConfirm from "./ResetPasswordConfirm.vue";
import { useGammaAuthenticator } from "@/composeable/gamma-authenticator";
import { AuthUIState } from "@/types/auth-ui";

export default defineComponent({
  components: {
    Signin,
    ForceNewPassword,
    ResetPassword,
    ResetPasswordConfirm,
  },
  setup() {
    return {
      AuthUIState,
      ...useGammaAuthenticator(),
    };
  },
});
